var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgArrowUp = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0028 8.17832L11.0028 18.2329C11.0028 18.7852 11.4505 19.2329 12.0028 19.2329C12.5551 19.2329 13.0028 18.7852 13.0028 18.2329L13.0028 8.18439L17.5248 12.7064C17.9154 13.0969 18.5485 13.0969 18.9391 12.7064C19.3296 12.3159 19.3296 11.6827 18.9391 11.2922L12.755 5.1081C12.5717 4.89908 12.3027 4.76712 12.0028 4.76712C12.0002 4.76712 11.9976 4.76713 11.9951 4.76715C11.7407 4.76834 11.4867 4.86597 11.2927 5.06003L5.0605 11.2922C4.66998 11.6827 4.66998 12.3159 5.0605 12.7064C5.45102 13.0969 6.08419 13.0969 6.47471 12.7064L11.0028 8.17832Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgArrowUp);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ArrowUp.4adb8f76acb0bdfea72e0fbf7294dd12.svg";